import React from 'react';

const PersoReportTableBody = ({ groupedData, styles, teamColors }) => {
  let indexCounter = 0;

  return (
    <tbody>
      {Object.keys(groupedData).map((teamName) => {
        const teamMembers = groupedData[teamName];
        return teamMembers.map((row, index) => {
          indexCounter++;
          return (
            <tr key={row.user}>
              <td style={{ ...styles.tableCell, ...styles.default }}>{indexCounter}</td>
              {index === 0 && (
                <td
                  style={{
                    ...styles.tableCell,
                    ...styles.teamCell,
                    backgroundColor: teamColors[teamName] || 'transparent',
                  }}
                  rowSpan={teamMembers.length}
                >
                  {teamName}
                </td>
              )}
              <td style={{ ...styles.tableCell, ...styles.default }}>{row.user.toString().replace('.', ',')}</td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.workingHoursPerDay.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.standardMonthlyHours.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.worked_hours.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>{row.worked_days.toString().replace('.', ',')}</td>
              <td style={{ ...styles.tableCell, ...styles.default, color: row.overtime_color }}>
                {row.overtime.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>{row.l4_hours.toString().replace('.', ',')}</td>
              <td style={{ ...styles.tableCell, ...styles.default }}>{row.l4_days.toString().replace('.', ',')}</td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.special_hours.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.special_days.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.childcare_hours.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.childcare_days.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.vacation_hours.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>
                {row.vacation_days.toString().replace('.', ',')}
              </td>
              <td style={{ ...styles.tableCell, ...styles.default }}>{row.total_sum.toString().replace('.', ',')}</td>
            </tr>
          );
        });
      })}
    </tbody>
  );
};

export default PersoReportTableBody;
